<template>
    <TWebIntegration
        v-if="isAppLoaded && canStart && isVisible"
        :style="themeStyles"
        :isAppLoaded="isAppLoaded"
    >
        <router-view />
    </TWebIntegration>
    <AInitialLoader v-else />
</template>

<script>
import { isMobileOnly } from 'mobile-device-detect';
import {
    mapActions,
    mapGetters
} from "vuex";

import TWebIntegration from '../../templates/t-web-integration';
import AInitialLoader from '../../atoms/a-initial-loader/a-initial-loader';

import { setMetaMobileTheme } from "../../../utils/helpers/mobile-theme-viewport-settings";
import {reportError} from "@/utils/helpers/health-monitoring";

export default {
    name: 'PWebIntegration',
    components: {
        AInitialLoader,
        TWebIntegration
    },
    data(){
        return {
            isVisible: this.isWindowVisible(),
            checkVisibilityInterval: null,
        }
    },
    computed: {
        ...mapGetters([
            'isAppLoaded',
            'getMapConfigProp'
        ]),
        canStart() {
            const m = window.Modernizr;
            return m && m.webgl && m.webworkers && m.webglextensions
        },
        themeStyles() {
            return this.getMapConfigProp('theme_styles') || null;
        }
    },
    created() {
        if (isMobileOnly) setMetaMobileTheme();
    },
    mounted() {
        this.loadMapData();
        this.checkVisibilityInterval = setInterval(this.checkVisibility, 300);
        this.checkVisibility();
        if(!this.isVisible) {
            reportError('Current iframe size is less than min resolution for MVG Map Integration what is 300x300px. Initialisation is posponed.');
        }
    },  
    methods: {
        ...mapActions([
            'fetchMapData'
        ]),
        async loadMapData() {
            try {
                const mapId = this.$route.params.mapId;
                await this.fetchMapData(mapId);
            } catch(error) {
                console.log('Data fetch error', error);
            }
        },
        isWindowVisible(){
            return Boolean(
                document.body.clientWidth >= 300 &&
                    document.body.clientHeight >= 300
            );           
        },  
        checkVisibility(){
            //if integration is in iframe that has display:none we should delay loading of the webgl part
            this.isVisible = this.isWindowVisible();
            this.isVisible && clearInterval(this.checkVisibilityInterval);
        }
    }
}
</script>
